import { Route, Routes } from "react-router-dom";

import {ReportDocumentLink } from "../../pages";

export const ReportDocumentLinkLayout = () =>{
  return (
    <Routes>
    <Route path="/" element={<ReportDocumentLink/>} />
  </Routes>
  )
}

    
  
